import { Entity } from '@hglobal/fin-ui';

import { Currency } from './currency.entities';

export enum UserOperationType {
  Deposit = 'Deposit',
  Transfer = 'Transfer',
  Withdrawal = 'Withdrawal',
  Exchange = 'Exchange',
  Refund = 'Refund',
  BalanceAdjustment = 'Balance Adjustment',
  CardOperation = 'Card Operation',
}

export enum TreasurerOperationType {
  Deposit = 'Deposit',
  Transfer = 'Transfer',
  MassPayout = 'MassPayout',
}

export enum OperationStatus {
  Cancelled = 'Cancelled',
  Created = 'Created',
  Completed = 'Completed',
  Successful = 'Successful',
  InProgress = 'In Progress',
  Rejected = 'Rejected',
  Failed = 'Failed',
  Reversed = 'Reversed',
  Temporary = 'Temporary',
  Declined = 'Declined',
  Expired = 'Expired',
  Refunded = 'Refunded',
}

export interface OperationDetails {
  from: string;
  to: string;
  fromName: string;
  toName: string;
  rate: string;
  convertedAmount: string;
  currency: string;
  currencyName: string;
  originalAmount?: string;
  originalCurrency?: string;
  targetCurrency?: string;
  amountToReceive?: string;
  targetCurrencyName?: string;
  category?: string;
}

export interface Operation extends Entity<string> {
  createdAt: string;
  updatedAt: string;
  type: string;
  status: string;
  commission: string;
  amount: string;
  description?: string;
  fromAccountId: string;
  toAccountId?: string;
  details: OperationDetails;
  statusTooltip?: string; // FE property
  currency?: Currency;
  currencyFrom?: Currency;
  currencyTo?: Currency;
}
